export default {
    items: [
        {
            topic: "HIV-free Generation",
            route: "hiv-free-generation",
            image: "group3b.jpg",
            goals: ["E_WEB_03.png"],
            descrip:
                "Since the first lab observing case in 1980s, we have seen the peak of HIV/AIDS infections in 2004. Now we are on the way to reduce new HIV infections, increase access to treatment and end AIDS-related deaths.<br><br>In our storymap, we addressed the following topics: History and current situation worldwide, heterogeneous distribution comparing Sub-Saharan Africa and western Europe, progress related to the sustainable development goals, and possible actions."
        },
        {
            topic: "Equality Education",
            route: "equality-education",
            image: "group2.jpg",
            goals: ["E_WEB_04.png"],
            descrip:
                "Quality Education aims to ensure inclusive and equitable education and promote lifelong learning opportunities for all. In this story, we focus on equal opportunites in education. Briefly speaking, we will give an overview of the current global education from the equality aspect, then explore the reasons behind and finally take a look at future trends."
        },
        {
            topic: "Gender Equality",
            route: "gender-equality",
            image: "group3.jpg",
            goals: ["E_WEB_05.png"],
            descrip:
                "In our story, we focused on the economic aspects of gender equality and addressed these subthemes:<ul><li>Gender Inequality Index</li><li>Wage Gap</li><li>Parental Leave</li><li>Employment</li><li>Employees in part time jobs</li></ul>Explore our story about gender equality through different maps, diagrams, images and explanatory texts, and discover regional differences."
        },
        {
            topic: "Affordable Energy",
            route: "affordable-energy",
            image: "group2b.jpg",
            goals: ["E_WEB_07.png"],
            descrip:
                "The SDG 7 goal is about sustainable and clean energy. Our storymap informs about energy in general and the worldwide development of renewable energy. We compare its consumption with other types of energy. Furthermore, we have a look at the accessibility and costs as well as imports and exports of energy. We conclude with assessing the impact on global greenhouse gas emissions. So, you can make up your mind if it is possible to reach the goals."
        },
        {
            topic: "Decent Work",
            route: "decent-work",
            image: "group4b.jpg",
            goals: ["E_WEB_08.png"],
            descrip:
                "Many countries suffer from a high youth unemployment rate. Our story shows how youth unemployment is distributed around the world and what differences exist between men and women. It demonstrates the connection between youth unemployment and a region's economic growth. The relationship between employment and educational attainment is also discussed. Finally, possible measures to reduce unemployment worldwide are described."
        },
        {
            topic: "Sustainable Mobility",
            route: "sustainable-mobility",
            image: "group1.jpg",
            goals: ["E_WEB_11.png"],
            descrip:
                "We live in a world of dynamics. Numerous people and goods are transported between cities and countries every day. However, the fast development of urbanization has posed various challenges on mobility such as accessibility, efficiency, and greenhouse emissions. These aspects can significantly influence the livability of a city. Therefore, in our story, we studied mobility in terms of coverage, connectivity, and sustainability. To realize this, we took a closer look at three successful cases in Zurich, Vancouver and Singapore."
        },

        {
            topic: "Meat Consumption",
            route: "meat-consumption",
            image: "group4.jpg",
            goals: ["E_WEB_12.png", "E_WEB_13.png"],
            descrip:
                "In this story, you can see if it is possible to reduce our CO2 emissions through changing our meat consumption habits. We assume an imaginary scenario in which chicken meat is consumed only. We estimate the CO2 savings and reforestation potential for different meat types. Finally, we calculate the current and a hypothetical land use index for the cantons of Zurich and Fribourg."
        },
        {
            topic: "Deforestation",
            route: "deforestation",
            image: "group1b.jpg",
            goals: ["E_WEB_15.png"],
            descrip:
                "Deforestation, as one of the biggest issues in our ecosystems, is always worthy of attention. Our story introduces you to what deforestation is and how we are making effort to fight against it. You would know more about this issue, from the reasons behind it to the current situation. Also, you would witness the fruitful contribution of what we have done to protect our forests. Finally, let's take action to save the forests, the ecosystems, and us."
        }
    ],
    current: null
}